import React, { useState } from "react";

import { connect } from "react-redux";

import ExpandedRow from "./ExpandedRow";
import Row from "./Row";
import { selectResumeById } from "../../../../redux/slices/resumeSlice";

/* =============================================================================
<ResumeScreeningCandidatesTableRow />
============================================================================= */
const ResumeScreeningCandidatesTableRow = ({
  page,
  resume,
  selectedRows,
  setSelectedRows,
  onRequestAssesment,
}) => {
  const [isRowExpended, setIsRowExpended] = useState(false);
  if (!resume) {
    return null;
  }
  return (
    <>
      {isRowExpended ? (
        <ExpandedRow
          page={page}
          resume={resume}
          isRowExpended={isRowExpended}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          onRequestAssesment={onRequestAssesment}
          onExpand={() => setIsRowExpended(false)}
        />
      ) : (
        <Row
          page={page}
          resume={resume}
          isRowExpended={isRowExpended}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          onRequestAssesment={onRequestAssesment}
          onExpand={() => setIsRowExpended(true)}
        />
      )}
    </>
  );
};

const mapStateToProps = (state, { id }) => ({
  resume: selectResumeById(state, id),
});

/* Export
============================================================================= */
export default connect(mapStateToProps)(ResumeScreeningCandidatesTableRow);
